<template>
  <section class="container mx-auto px-4 md:px-8 py-10 md:py-14">
    <h1 class="text-3xl md:text-4xl font-extrabold mb-8">Доставка та оплата</h1>

    <!-- Навігація-якорі -->
    <nav class="flex flex-wrap gap-3 mb-8 text-sm">
      <a href="#delivery" class="px-3 py-2 rounded-full border hover:bg-gray-50"
        >Доставка</a
      >
      <a href="#payment" class="px-3 py-2 rounded-full border hover:bg-gray-50"
        >Оплата</a
      >
      <a href="#returns" class="px-3 py-2 rounded-full border hover:bg-gray-50"
        >Повернення/Обмін</a
      >
      <a href="#faq" class="px-3 py-2 rounded-full border hover:bg-gray-50"
        >FAQ</a
      >
    </nav>

    <!-- GRID -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <!-- Ліва колонка: доставкa + оплата -->
      <div class="lg:col-span-2 space-y-8">
        <!-- Доставка -->
        <section id="delivery" class="border rounded-2xl p-6">
          <div class="flex items-center gap-3 mb-4">
            <Truck :size="22" />
            <h2 class="text-xl font-semibold">Доставка по Україні</h2>
          </div>

          <div class="space-y-5 text-gray-800">
            <div class="flex items-center gap-4">
              <img
                src="/img/np-logo.png"
                alt="Нова Пошта"
                width="112"
                height="28"
                class="h-7 w-auto"
                loading="lazy"
                decoding="async"
              />
              <p>
                <b>Нова Пошта</b> — до відділення/поштомату або курʼєром. Строк:
                <b>2–5 днів</b>.
              </p>
            </div>

            <ul class="list-disc ml-6 space-y-1">
              <li>Відправляємо замовлення щоденно (пн-нд).</li>
              <li>
                Вартість згідно тарифів перевізника (часто: <b>~80–120 грн</b>).
              </li>
              <li>
                Безкоштовна доставка від <b>3000 грн</b> (акції можуть
                змінюватись).
              </li>
              <li>Після відправки надішлемо ТТН.</li>
            </ul>
          </div>
        </section>

        <!-- Оплата -->
        <section id="payment" class="border rounded-2xl p-6">
          <div class="flex items-center gap-3 mb-4">
            <CreditCard :size="22" />
            <h2 class="text-xl font-semibold">Способи оплати</h2>
          </div>

          <div class="grid sm:grid-cols-2 gap-6">
            <div class="border rounded-xl p-4">
              <div class="flex items-center gap-2 mb-2">
                <ShieldCheck :size="18" />
                <h3 class="font-semibold">Онлайн карткою</h3>
              </div>
              <p class="text-sm text-gray-700">
                Visa/Mastercard, Apple/Google Pay (через платіжного провайдера).
                Платіж захищено, чек на email.
              </p>
            </div>

            <div class="border rounded-xl p-4">
              <div class="flex items-center gap-2 mb-2">
                <Wallet :size="18" />
                <h3 class="font-semibold">Післяплата</h3>
              </div>
              <p class="text-sm text-gray-700">
                Оплата у відділенні Нової Пошти при отриманні. Комісія згідно
                тарифів перевізника.
              </p>
            </div>

            <div class="border rounded-xl p-4">
              <div class="flex items-center gap-2 mb-2">
                <Landmark :size="18" />
                <h3 class="font-semibold">Банківський переказ</h3>
              </div>
              <p class="text-sm text-gray-700">
                Реквізити надсилаємо після підтвердження замовлення менеджером.
              </p>
            </div>

            <div class="border rounded-xl p-4">
              <div class="flex items-center gap-2 mb-2">
                <Package :size="18" />
                <h3 class="font-semibold">Самовивіз (за домовленістю)</h3>
              </div>
              <p class="text-sm text-gray-700">
                Київ. Місце і час оговорюємо індивідуально у месенджері.
              </p>
            </div>
          </div>
        </section>

        <!-- Повернення/Обмін -->
        <!-- <section id="returns" class="border rounded-2xl p-6">
          <div class="flex items-center gap-3 mb-4">
            <RefreshCw :size="22" />
            <h2 class="text-xl font-semibold">Повернення та обмін</h2>
          </div>
          <div class="space-y-3 text-gray-800">
            <p>
              Ви можете оформити повернення або обмін протягом <b>14 днів</b> з
              моменту отримання.
            </p>
            <ul class="list-disc ml-6 space-y-1 text-gray-700">
              <li>
                Виріб має бути без слідів носіння, із збереженими бирками та
                пакуванням.
              </li>
              <li>
                Текстиль, що контактує зі шкірою (наволочки), приймаємо, якщо не
                використовувався.
              </li>
              <li>
                Вартість зворотної доставки — за рахунок покупця (крім
                виробничого браку).
              </li>
            </ul>
            <p>
              Для оформлення — напишіть нам у
              <NuxtLink to="/contacts" class="underline hover:text-pink-200"
                >Контакти</NuxtLink
              >.
            </p>
          </div>
        </section> -->

        <!-- FAQ -->
        <!-- <section id="faq" class="border rounded-2xl p-6">
          <div class="flex items-center gap-3 mb-4">
            <HelpCircle :size="22" />
            <h2 class="text-xl font-semibold">Поширені питання</h2>
          </div>

          <div class="divide-y">
            <details class="py-3 group">
              <summary
                class="cursor-pointer list-none flex items-center justify-between"
              >
                <span class="font-medium">Коли відправка замовлення?</span>
                <ChevronDown
                  class="transition group-open:rotate-180"
                  :size="18"
                />
              </summary>
              <p class="mt-2 text-sm text-gray-700">
                Щоденно (пн-нд). Замовлення, оформлені до 16:00, як правило
                відправляємо того ж дня.
              </p>
            </details>

            <details class="py-3 group">
              <summary
                class="cursor-pointer list-none flex items-center justify-between"
              >
                <span class="font-medium">Чи є примірка у відділенні НП?</span>
                <ChevronDown
                  class="transition group-open:rotate-180"
                  :size="18"
                />
              </summary>
              <p class="mt-2 text-sm text-gray-700">
                Так, можна приміряти у відділенні Нової Пошти (за правилами
                перевізника).
              </p>
            </details>

            <details class="py-3 group">
              <summary
                class="cursor-pointer list-none flex items-center justify-between"
              >
                <span class="font-medium">Як вибрати розмір?</span>
                <ChevronDown
                  class="transition group-open:rotate-180"
                  :size="18"
                />
              </summary>
              <p class="mt-2 text-sm text-gray-700">
                Скористайтесь таблицею розмірів на сторінці товару або напишіть
                нам — допоможемо підібрати.
              </p>
            </details>
          </div>
        </section> -->
      </div>

      <!-- Права колонка: картка з короткими підказками -->
      <aside class="space-y-6">
        <div class="border rounded-2xl p-6">
          <h3 class="text-lg font-semibold mb-2">Як це працює?</h3>
          <ol class="list-decimal ml-5 space-y-1 text-sm text-gray-700">
            <li>Оберіть товар/розмір та додайте у кошик.</li>
            <li>Оформіть замовлення — вкажіть контакти й спосіб доставки.</li>
            <li>Оплатіть онлайн або оберіть післяплату.</li>
            <li>Отримайте ТТН і відстежуйте відправлення.</li>
          </ol>
          <NuxtLink
            to="/catalog"
            class="mt-4 inline-block px-5 py-2 rounded-xl bg-pink-200 text-black hover:bg-pink-200/80 transition text-sm"
          >
            Дивитись каталог
          </NuxtLink>
        </div>

        <div class="border rounded-2xl p-6">
          <h3 class="text-lg font-semibold mb-2">Потрібна допомога?</h3>
          <p class="text-sm text-gray-700 mb-3">
            Напишіть у месенджер — відповідаємо швидко.
          </p>
          <div class="flex flex-wrap gap-2">
            <a
              href="https://t.me/mulberry_ss"
              target="_blank"
              class="px-4 py-2 rounded-xl bg-pink-200 text-black hover:bg-pink-200/80 text-sm"
              >Telegram</a
            >
            <a
              href="https://ig.me/m/mulberry_silk_studio"
              target="_blank"
              class="px-4 py-2 rounded-xl bg-pink-200 text-black hover:bg-pink-200/80 text-sm"
              >Instagram</a
            >
            <NuxtLink
              to="/contacts"
              class="px-4 py-2 rounded-xl border hover:bg-gray-50 text-sm"
              >Контакти</NuxtLink
            >
          </div>
        </div>
      </aside>
    </div>
  </section>
</template>

<script setup>
import {
  Truck,
  CreditCard,
  Wallet,
  Landmark,
  Package,
  RefreshCw,
  ShieldCheck,
  HelpCircle,
  ChevronDown,
} from "lucide-vue-next";

useHead({ title: "Доставка та оплата — mulberry’ss" });
</script>
